import { render, staticRenderFns } from "./CustomersCharts.vue?vue&type=template&id=696e5d82&scoped=true&"
import script from "./CustomersCharts.vue?vue&type=script&lang=js&"
export * from "./CustomersCharts.vue?vue&type=script&lang=js&"
import style0 from "./CustomersCharts.vue?vue&type=style&index=0&id=696e5d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e5d82",
  null
  
)

export default component.exports